export default __webpack_public_path__ + "static/tech-nation-1-6901b887e89cb9221156eceda1dcc71c.webp";